import { createDuck } from '@/utils'
import { addCart } from '@/services/api/common'
import { getDiscountData } from '@/services/api/discount'
import { Toast } from 'antd-mobile-v2'

export const duck = createDuck({
  name: 'discountDuck',

  /** @type {DiscountStates} */
  initialState: {},
  actions: {
    fetchData(actId) {
      return async dispatch => {
        const { data, error } = await getDiscountData(actId)
        if (!error) {
          const { mallActivityInfo, goods, postage } = data
          dispatch(
            duck.change({
              [actId]: {
                state: 1,
                visible: false,
                goods: Array.isArray(goods) ? goods : [],
                mallActivityInfo,
                alreadyBuyNums: mallActivityInfo && mallActivityInfo.alreadyBuyNums,
                postage,
                curItem: {
                  defaultSubItem: {},
                  count: 1,
                  subItems: [],
                  status: 0,
                },
              },
            }),
          )
        } else {
          Toast.show(error.message || '获取数据失败')
        }
      }
    },

    toggelModal(val, actId) {
      return (dispatch, getState) => {
        const { discountDuck } = getState()
        const preData = discountDuck[actId] || {}
        dispatch(
          duck.change({
            [actId]: {
              ...preData,
              visible: val,
            },
          }),
        )
      }
    },
    changeCurItem(data, actId) {
      return (dispatch, getState) => {
        const { discountDuck } = getState()
        const preData = discountDuck[actId] || {}
        dispatch(
          duck.change({
            [actId]: {
              ...preData,
              curItem: {
                ...data,
                count: 1,
              },
              visible: true,
            },
          }),
        )
      }
    },

    //添加到购物车
    addCart(data, activityIds) {
      return async (dispatch, getState) => {
        const { discountDuck } = getState()
        const preData = discountDuck[activityIds] || {}
        //判断是否为预售商品
        const { error } = await addCart({
          count: data.count,
          subItemId: data.subItemId,
          choice: data.status === 100 ? false : true,
        })
        if (!error) {
          Toast.info('添加商品成功')
          dispatch(duck.fetchData(activityIds))
        } else {
          Toast.info((error && error.message) || '加入购物车失败')
        }
        dispatch(
          duck.change({
            [activityIds]: {
              ...preData,
              visible: false,
            },
          }),
        )
      }
    },
  },
})
